import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useNotificaciones } from "@/hooks/useNotificaciones";

export default function NotificationBell({ to, scope = "auto" }) {
  const { user } = useAuth();
  const { total, items } = useNotificaciones(30000, scope);
  const defaultTo = user?.rol === "worker" ? "/mis-notificaciones" : "/admin/solicitudes";
  const destino = to || items[0]?.url || defaultTo;

  return (
    <Link
      to={destino}
      className="relative rounded-lg p-2 text-indigo-600 transition-colors hover:bg-indigo-50"
      data-testid="notificaciones-bell"
      title={total ? `${total} aviso(s) pendiente(s)` : "Mis avisos"}
    >
      <Bell className="h-5 w-5" strokeWidth={1.5} />
      {total > 0 && (
        <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-500 px-1 text-[10px] font-bold text-white">
          {total > 9 ? "9+" : total}
        </span>
      )}
    </Link>
  );
}
